export default __webpack_public_path__ + "static/media/baseline-battery_60-24px.fb3c609d.svg";